import { render, staticRenderFns } from "./StudentImporter.vue?vue&type=template&id=3d9824c4"
import script from "./StudentImporter.vue?vue&type=script&lang=js"
export * from "./StudentImporter.vue?vue&type=script&lang=js"
import style0 from "./StudentImporter.vue?vue&type=style&index=0&id=3d9824c4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports